import {BindGroupName} from '@mintdata/mint-kit/api/decorators/Editor';
import {serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

export type FieldPath = string;

export class BindPath
{
    @serializable public readonly bindGroupName:BindGroupName;
    @serializable public readonly fieldPath:FieldPath;

    public constructor(bindGroupName:BindGroupName = BindPath.DEFAULT_BIND_GROUP_ID,
                       fieldPath:FieldPath = BindPath.ROOT_FIELD_PATH)
    {
        this.bindGroupName = bindGroupName;
        this.fieldPath = fieldPath && fieldPath.replace(/.+[.]$/, '');
    }

    public static readonly DEFAULT_BIND_GROUP_ID = 'default';
    public static readonly ROOT_FIELD_PATH = '.';
    public static readonly ARRAY_PATH_TEMPLATE = '[*]';
    public static readonly ROOT_ARRAY_FIELD_PATH = `${BindPath.ROOT_FIELD_PATH}${BindPath.ARRAY_PATH_TEMPLATE}`;
    public static readonly ROOT_ARRAY_FIELD_PATH_REGEX = /\.\[\d+\]/;
    public static readonly ARRAY_FIELD_PATH_REGEX = /\[(\d+|\*)\]/g;

    public isEqual(other:BindPath):boolean
    {
        return other && other.bindGroupName === this.bindGroupName && other.fieldPath === this.fieldPath;
    }

    public static defaultBindGroup(fieldPath:FieldPath):BindPath
    {
        return new BindPath(
            null,
            fieldPath
        );
    }

    public static rootFieldPath():BindPath
    {
        return new BindPath();
    }

    public static isRootPath(fieldPath:FieldPath):boolean
    {
        return fieldPath
            && (fieldPath === BindPath.ROOT_FIELD_PATH
                || fieldPath === BindPath.ROOT_ARRAY_FIELD_PATH
                || !!fieldPath.match(BindPath.ROOT_ARRAY_FIELD_PATH_REGEX));
    }

    public static splitFieldPath(fieldPath:FieldPath,
                                 rootFieldPath:FieldPath = BindPath.ROOT_FIELD_PATH):Array<FieldPath>
    {
        if( BindPath.isRootPath(fieldPath) )
            return [fieldPath];
        else
        {
            const fieldPathParts:Array<FieldPath> = fieldPath.replace(/^\./, '').split('.');

            return [rootFieldPath, ...fieldPathParts];
        }
    }

    public static combineFieldPaths(fieldPath1:FieldPath, fieldPath2:FieldPath):FieldPath
    {
        if( fieldPath1 === BindPath.ROOT_FIELD_PATH && fieldPath2 !== BindPath.ROOT_FIELD_PATH )
            return fieldPath2;

        return [
            fieldPath1 !== BindPath.ROOT_FIELD_PATH ? fieldPath1 : '',
            fieldPath2 !== BindPath.ROOT_FIELD_PATH ? fieldPath2 : ''
        ].join('.');
    }
}
